module.exports = __webpack_public_path__ + "media/images/diamonds-ee8114412d7220f9647c54ca5a262616.png";